import React, { ReactNode, FC } from 'react';
import { useApiTendersCtx } from './hooks';
import { createApiTendersCtx } from './context';
import { MappedTendersTypes } from './types';

type Props = { children: ReactNode; type: keyof MappedTendersTypes };
export const ApiTendersProvider: FC<Props> = ({ children, type }) => {
  const ApiTendersCtx = createApiTendersCtx();
  const ctxValue = useApiTendersCtx(type);

  return <ApiTendersCtx.Provider value={ctxValue}>{children}</ApiTendersCtx.Provider>;
};
